export default __webpack_public_path__ + "static/media/purchase.a4aa1366.jpeg";